import { AxiosInstance } from 'axios';
import { useCallback } from 'react';
import { METHODS } from './useContentApi';
import { useLoading } from './useLoading';

export const useSaveContentPublication = ({
  api,
  workspaceId,
}: {
  api: AxiosInstance;
  workspaceId: string;
}) => {
  const saveContentPublication = useCallback(
    async (body) => {
      let url;
      let method;
      const contentUrl = `/content/${body.contentId}`;

      if (body.publicationId) {
        url = `${contentUrl}/publications/${body.publicationId}`;
        method = METHODS.PUT;
      } else {
        url = `${contentUrl}/publications`;
        method = METHODS.POST;
      }

      const { data } = await api(url, {
        method,
        data: { ...body, workspaceId },
      });

      return data;
    },
    [api, workspaceId],
  );

  return useLoading(saveContentPublication);
};
